<p class="!m-0 text-center">
  {{data.message}}
</p>